/** @module Enums */ /** typedoc */

// When adding KIND here, don't forget the 'TrackTypeEnum' from Falcor
export enum LibraryItemEnum {
    stem = 'stem',
    track = 'track',
    video = 'video',
    album = 'album',
    videoTrack = 'videoTrack'
}
